import { render, staticRenderFns } from "./manage-activity-groups.vue?vue&type=template&id=3a7caf8a&scoped=true&"
import script from "./manage-activity-groups.vue?vue&type=script&lang=js&"
export * from "./manage-activity-groups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7caf8a",
  null
  
)

export default component.exports